<template>
  <div class="progress-bar">
    <div class="progress-bar__label">{{$tAddResume('Fill percentage')}}<span class="progress-bar__val" v-if="inlineVal">{{progress}}%</span></div>
    <div class="progress-bar__content">
      <div class="progress-bar__val" v-if="!inlineVal">{{progress}}%</div>
      <div class="progress-bar__progress">
        <div class="progress-bar__bar" :style="`width: ${progress}%`"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      progress: {
        type: Number,
        default: 0
      },
      inlineVal: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>

</style>
